import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import { HOME } from "@/constants/testIds";

const PHONE_DISPLAY = "+91 83104 76246";
const PHONE = "+918310476246";
const WA_URL = "https://wa.me/918310476246";

const Footer = () => {
    return (
        <footer className="bg-[#0F2118] text-[#E8E6DB]">
            <div className="mx-auto max-w-7xl px-5 md:px-10 py-16">
                <div className="grid gap-10 md:grid-cols-4">
                    <div className="md:col-span-2">
                        <div className="flex flex-col leading-tight">
                            <span className="font-display text-3xl md:text-4xl text-[#FAFAF5]">
                                Netravathi
                            </span>
                            <span className="mt-1 text-[11px] uppercase tracking-[0.32em] text-[#C46A42] font-medium">
                                Tours &amp; Travels · Since 2014
                            </span>
                        </div>
                        <p className="mt-6 max-w-md text-[#B7BFB6] leading-relaxed">
                            A small, dependable travel team turning Western
                            Ghats journeys into stories worth telling. Call or
                            message us — we're always around.
                        </p>
                    </div>

                    <div>
                        <div className="text-xs uppercase tracking-[0.24em] opacity-70">
                            Reach us
                        </div>
                        <div className="mt-4 flex flex-wrap items-center gap-3">
                            <a
                                data-testid={HOME.footerPhone}
                                href={`tel:${PHONE}`}
                                className="inline-flex items-center gap-2 rounded-full bg-[#FAFAF5] text-[#1B3B2B] px-4 py-2.5 text-sm font-medium hover:bg-white hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
                            >
                                <Phone className="h-4 w-4" />
                                {PHONE_DISPLAY}
                            </a>
                            <a
                                data-testid={HOME.footerWhatsapp}
                                href={WA_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white px-4 py-2.5 text-sm font-medium hover:bg-[#1EAE53] hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
                            >
                                <MessageCircle className="h-4 w-4" />
                                Chat on WhatsApp
                            </a>
                        </div>
                        <div className="mt-6 flex items-start gap-2 text-sm text-[#B7BFB6]">
                            <Clock className="mt-0.5 h-4 w-4 shrink-0" />
                            <span>Open 24 Hours · All 7 days</span>
                        </div>
                    </div>

                    <div>
                        <div className="text-xs uppercase tracking-[0.24em] opacity-70">
                            Visit
                        </div>
                        <div
                            data-testid={HOME.footerAddress}
                            className="mt-4 flex items-start gap-2 text-sm text-[#B7BFB6] leading-relaxed"
                        >
                            <MapPin className="mt-0.5 h-4 w-4 shrink-0" />
                            <span>
                                Near KEB Office, MRS Circle,
                                <br />
                                Vidya Nagar, Shivamogga,
                                <br />
                                Karnataka
                            </span>
                        </div>
                    </div>
                </div>

                <div className="mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-white/10 pt-6 text-xs text-[#8A9089]">
                    <div>
                        © {new Date().getFullYear()} Netravathi Tours &amp;
                        Travels, Shivamogga. Journeys planned with heart.
                    </div>
                    <div>5.0 ★ · 23 traveller reviews</div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
